import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { FormRenderProps } from "react-final-form";
import { Field } from "react-final-form";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "../../../../components/Autocomplete";
import BootstrapInput from "../../../../components/BootstrapInput";
import Button from "../../../../components/Button";
import { EDUCATION_TYPES } from "../../../school/constants/types";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    marginBottom: 4,
    display: "flex",
    alignItems: "flex-end",

    "& > button": {
      paddingTop: "10px!important",
      paddingBottom: "10px!important",
    },
  },
}));

const FilterForm: FC<FormRenderProps> = ({
  submitting,
  submitError,
  handleSubmit,
}) => {
  const classes = useStyles();

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <Field
            fullWidth
            name="schoolType"
            label="School Type"
            placeholder="School Type"
            options={EDUCATION_TYPES}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="keyword"
            label="Search any School"
            placeholder="Search by user name, user email address or school name"
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12} sm={3} className={classes.buttonContainer}>
          <Button
            fullWidth
            type="submit"
            color="success"
            variant="contained"
            disabled={submitting}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default React.memo(FilterForm);
